import Component from '@glimmer/component';

export default class IssuesFormBounceSelectorComponent extends Component {}
